import { Injectable, inject } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class NavigationService {
    private readonly router = inject(Router);
    private history: string[] = [];

    constructor() {
        this.router.events.pipe(
            filter(event => event instanceof NavigationEnd)
        ).subscribe({
            next: (event: any) => {
                const url = event.urlAfterRedirects;
                if (!this.history.length || this.history[this.history.length - 1] !== url) {
                    this.history.push(url);
                }
            },
            // Without an error callback, a navigation failure severe enough to error the
            // Observable (rather than emit as a NavigationError/NavigationCancel event, which
            // this service already tolerates via the NavigationEnd filter above) would propagate
            // as an UNCAUGHT exception AND permanently kill this subscription - this service is
            // a singleton (providedIn: 'root'), so the whole app's history/getPreviousUrl()/
            // navigateBack() (see header.component.ts's goBack()) would silently stop updating
            // for the rest of the session over one unrelated navigation elsewhere. Logged, not
            // resubscribed - retrying against an already-errored Router event stream risks a
            // tight synchronous error loop instead of recovering anything.
            error: (err: any) => {
                console.error('[NavigationService] router.events errored - history tracking stopped for this session:', err);
            }
        });
    }

    // Pop le stack et retourne l'URL précédente (ou null si pas d'historique)
    navigateBack(): string | null {
        if (this.history.length < 2) return null;
        this.history.pop();
        return this.history[this.history.length - 1] ?? null;
    }

    getPreviousUrl(): string | null {
        if (this.history.length < 2) return null;
        return this.history[this.history.length - 2] ?? null;
    }
}
